import React from 'react';
import { PrimaryButton, SecondaryButton } from '@JohnLewisPartnership/jl-design-system/dist/elements/button/Button';
import styles from './EmailMeModalContent.module.scss';
import EmailModalStore from '../../stores/EmailModalStore/EmailModalStore';
import { TextInput } from '@JohnLewisPartnership/jl-design-system/dist/components/text-input/TextInput';
import { observer } from 'mobx-react-lite';
import { WishlistFilled } from '@JohnLewisPartnership/jl-design-system/dist/components/icons/WishlistFilled';

export interface EmailMeModalContentProps {
    emailModalStore: EmailModalStore;
    onCancel: () => void;
    onNotify: () => void;
}

export const EmailMeModalContent: React.FC<EmailMeModalContentProps> = observer(
    ({ emailModalStore, onCancel, onNotify }) => {
        const { emailMeSubmitting, emailMeEmailError, toggleEmailFieldTouched } = emailModalStore;

        return (
            <div id="email-me-modal-content" className={styles.modalContent} data-testid="email-me-modal-content">
                <div className={styles.notificationContainer}>
                    <WishlistFilled size="medium" />
                    <p className={styles.notificationText}>We&apos;ve added this item to your wish list.</p>
                </div>
                <>
                    <p className={styles.infoText}>
                        If you&apos;d like to be notified when it&apos;s available, enter your email address below.
                    </p>

                    <p className={styles.infoText}>
                        If it doesn&apos;t come back into stock, we&apos;ll help you with similar product suggestions.
                    </p>

                    <div className={styles.fullWidth}>
                        <TextInput
                            id="email-me-id"
                            labelText="Email"
                            name="email-me-email"
                            value={emailModalStore.customerEmail}
                            data-testid="email-me-form"
                            onBlur={toggleEmailFieldTouched}
                            onFocus={(): void => {
                                // this is just here to suppress a console error
                                return;
                            }}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                                emailModalStore.customerEmail = e.target.value;
                            }}
                            errorText={emailMeEmailError}
                            type="email"
                        />
                    </div>

                    <div className={styles.buttonContainer}>
                        <SecondaryButton inline data-testid="cancel-btn" onClick={onCancel}>
                            Cancel
                        </SecondaryButton>
                        <PrimaryButton
                            inline
                            data-testid="continue-btn"
                            submitting={emailMeSubmitting}
                            onClick={onNotify}
                        >
                            Notify me
                        </PrimaryButton>
                    </div>
                </>
            </div>
        );
    },
);
